<app-citizen-header></app-citizen-header>
<div class="p-2">
  <app-portal-title-bar [title]="'Taarifa za Mrejesho'"></app-portal-title-bar>
</div>
<div class="px-2 pb-4">
  <div *ngIf="(myFeedbacks | async) as feedback" >
   <div class="bg-white shadow-md rounded-md p-3">
     <div class="flex bg-green-50 p-2 mb-2 rounded-md items-center">
       <div>Kumbukumbu namba ya mrejsho:</div>
       <div class="bg-green-200 p-2 rounded-md ml-2 flex items-center !text-green-800">
         {{feedback?.trackNumber}}
       </div>
       <button class="!bg-green-800 ml-2 !text-white p-1 rounded-md" (click)="copyToClipboard(feedback?.trackNumber)">
         <mat-icon>content_copy</mat-icon>
       </button>
       <div class="ml-2">
         {{alert}}
       </div>
     </div>

     <div class="flex mb-2 flex-col">
       <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Kichwa cha Mrejesho</div>
       <div class="border-b border-gray-300 !text-gray-600 p-2">
         {{feedback?.title}}
       </div>
     </div>

     <div class="grid grid-cols-2 gap-4">
       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Aina ya Mrejeshoo</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.feedbackType}}
         </div>
       </div>

       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Jina la Huduma</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.service?.serviceName}}
         </div>
       </div>
     </div>

     <div class="grid grid-cols-2 gap-4">
       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Maelezo ya Mrejesho</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.description}}
         </div>
       </div>

       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Mapendekezo</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.suggestions}}
         </div>
       </div>
     </div>

     <div class="grid grid-cols-4 gap-4">
       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Mkoa</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.region?.reginalName}}
         </div>
       </div>

       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Wilaya</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.district?.districName}}
         </div>
       </div>

       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Kata</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.ward?.wardName}}
         </div>
       </div>

       <div class="flex mb-2 flex-col">
         <div class="bg-gray-50 !text-gray-600 p-2 rounded-md !font-black text-md">Mtaa</div>
         <div class="border-b border-gray-300 !text-gray-600 p-2">
           {{feedback?.street?.streetName}}
         </div>
       </div>
     </div>

   </div>

    <div *ngIf="feedback?.feedbackComplaintEvidences?.length > 0" class="mt-3 bg-white shadow-md rounded-md p-3">
      <div class="!font-black !text-xl">Feedback Evidence</div>
      <div class="flex flex-wrap space-x-2 mt-2">
        <span *ngFor="let evidence of feedback?.feedbackComplaintEvidences" (click)="openAttachment(evidence?.attachmentPath)" class="bg-primary-500 cursor-pointer text-white px-3 py-2 rounded-full">{{evidence?.name}}</span>
      </div>
    </div>
  </div>

  <div *ngIf="complaintTracking" class="pt-3 border-t mt-3">
    <div class="bg-white move-left shadow-md p-3 rounded-xl">
      <h3 class="text-lg !font-bold text-primary-500">Matokeo ya Ufuatiliaji</h3>
      <div class="mt-3 grid grid-cols-2 gap-2">
        <div *ngIf="complaintTracking.trackNo" class="flex flex-col">
          <div class="bg-gray-50 text-gray-700 p-2 rounded-md mb-2">
            Track Number
          </div>
          <p class="pb-2 border-b">{{ complaintTracking.trackNo }}</p>
        </div>
        <div *ngIf="complaintTracking.status" class="flex flex-col">
          <div class="bg-gray-50 text-gray-700 p-2 rounded-md mb-2">
            Status
          </div>
          <p class="pb-2 border-b">{{ complaintTracking.status }}</p>
        </div>

        <div *ngIf="complaintTracking.stageName"  class="flex flex-col">
          <div class="bg-gray-50 text-gray-700 p-2 rounded-md mb-2">
            Stage Name
          </div>
          <p class="pb-2 border-b">{{ complaintTracking.stageName }}</p>
        </div>

        <div *ngIf="complaintTracking.registrationDate" class="flex flex-col">
          <div class="bg-gray-50 text-gray-700 p-2 rounded-md mb-2">
            Registration Date
          </div>
          <p class="pb-2 border-b">{{ complaintTracking.registrationDate }}</p>
        </div>

        <div *ngIf="complaintTracking.closingRemarks" class="flex flex-col col-span-2">
          <div class="bg-gray-50 text-gray-700 p-2 rounded-md mb-2">
            Closing Remarks
          </div>
          <p class="pb-2 border-b">{{ complaintTracking.closingRemarks || 'N/A' }}</p>
        </div>

        <div *ngIf="complaintTracking.message" class="flex flex-col col-span-2">
          <div class="bg-gray-50 font-bold text-gray-700 p-2 rounded-md mb-2">
            Message
          </div>
          <p class="pb-2 border-b">{{ complaintTracking.message || 'N/A' }}</p>
        </div>

      </div>
    </div>
  </div>
</div>
